import filtype from './filtype'

const ulykkestyperapporter = {
    moteulykker: {
        aktivertITrine: true,
        tekniskNavn: 'moteulykker',
        visningsnavn: 'Møteulykker',
        filtyper: [filtype.pdf]
    },
    utforkjoringsulykker: {
        aktivertITrine: true,
        tekniskNavn: 'utforkjoringsulykker',
        visningsnavn: 'Utforkjøringsulykker',
        filtyper: [filtype.pdf]
    },
    kryssulykker: {
        aktivertITrine: false,
        tekniskNavn: 'kryssulykker',
        visningsnavn: 'Kryssulykker',
        filtyper: [filtype.pdf, filtype.xlsx]
    },
    ulykker_samme_kjoreretning: {
        aktivertITrine: false,
        tekniskNavn: 'ulykker_samme_kjoreretning',
        visningsnavn: 'Ulykker samme kjøreretning',
        filtyper: [filtype.pdf, filtype.xlsx]
    }
}

export default ulykkestyperapporter
